/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'goal-content.goal-about-content.description-edit-button': 'Editar',
  'project-actions.project-content-about.edit-description-error-description':
    'Algo ha ido mal. Inténtalo de nuevo en unos minutos.',
  'project-content.project-content-about.edit-description-error-title': 'Error al editar la descripción del proyecto',
  'project-content.project-content-about.the-measure-placeholder': 'Describe cómo es el éxito y qué esperas conseguir.',
  'project-content.project-content-about.the-measure-title': 'Cómo sabremos que tenemos éxito',
  'project-content.project-content-about.the-what-placeholder': 'Describe este proyecto y la actividad que conlleva.',
  'project-content.project-content-about.the-what-title': 'Qué hacemos',
  'project-content.project-content-about.the-why-placeholder':
    'Explica por qué esta actividad está tenido lugar y las razones que la impulsan.',
  'project-content.project-content-about.the-why-title': 'Por qué lo hacemos',
  'project-content.project-content-update-date.edited': '(editado)',
  'project-content.project-content-update-date.edited-tooltip': 'Fecha de edición: {date}',
  'project-content.project-content-update-date.last-edited-by': '(última edición por {name})',
  'project-content.project-content-updates.add-update': 'Añadir actualización',
  'project-content.project-content-updates.archived': 'Archivado',
  'project-content.project-content-updates.at-risk': 'En riesgo',
  'project-content.project-content-updates.cancelled': 'Cancelado',
  'project-content.project-content-updates.completed': 'Completados 🎉',
  'project-content.project-content-updates.date-changed': 'Fecha cambiada',
  'project-content.project-content-updates.edit-update': 'Editar',
  "project-content.project-content-updates.for-date'": 'para {dueDate}',
  'project-content.project-content-updates.latest-update-title': 'Última actualización',
  'project-content.project-content-updates.missed-update-message': 'No se ha publicado ninguna actualización',
  'project-content.project-content-updates.new-due-date': 'Nueva fecha de vencimiento',
  'project-content.project-content-updates.new-state': 'Nuevo estado',
  'project-content.project-content-updates.no-updates-description': 'Aún no hay actualizaciones para este proyecto.',
  'project-content.project-content-updates.off-track': 'No según lo previsto',
  'project-content.project-content-updates.old-due-date': 'Antigua fecha de vencimiento',
  'project-content.project-content-updates.old-state': 'Antiguo estado',
  'project-content.project-content-updates.on-track': 'Según lo previsto',
  'project-content.project-content-updates.paused': 'En pausa',
  'project-content.project-content-updates.pending': 'Pendiente',
  'project-content.project-content-updates.previous-updates-title': 'Actualizaciones anteriores',
  'project-content.project-content-updates.share-update': 'Compartir',
  'project-content.project-content-updates.status-changed': 'Estado cambiado',
  'project-content.project-content-updates.write-update-button': 'Escribir una actualización',
  'project-update-composer.modal-post-button-label': 'Publicar actualización',
  'project-update-composer.modal-title': 'Publica tu actualización',
};
